import { Link } from "react-router-dom";
import { gossipStats } from "@/mocks/gossipList";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden" aria-labelledby="hero-title">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20of%20an%20empty%20theater%20stage%20with%20crossing%20amber%20and%20crimson%20spotlight%20beams%2C%20drifting%20haze%2C%20velvet%20curtains%2C%20moody%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=gw-hero-30&orientation=landscape"
          alt="瓜网30大盘点专题封面 - 舞台灯光与事件脉络意象"
          title="瓜网30 · 30个瓜大盘点"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24 lg:py-28">
        <div className="max-w-3xl gw-rise">
          <p className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-200 border border-accent-400/50 rounded-full px-3 py-1.5 mb-5">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-bookmark-3-line"></i>
            </span>
            2026 · 第九期大盘点 · 已按条整理
          </p>

          <h1 id="hero-title" className="font-heading font-black text-3xl md:text-5xl lg:text-[56px] leading-tight text-white">
            30 个瓜，一页看完
            <span className="block text-accent-300 mt-2 text-2xl md:text-4xl lg:text-[42px]">
              按条汇总爆料与事件脉络
            </span>
          </h1>

          <p className="mt-5 text-sm md:text-base text-white/80 leading-relaxed max-w-2xl">
            从起因到发酵，从第一次爆料到最新进展，我们把近一个月讨论度最高的 30 条娱乐事件拆成条目，
            每条标注核心人物与冲突点，让你不必翻遍碎片信息，也能快速建立整体认知。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center">
            <Link
              to="/rankings"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              查看完整 30 条大盘点
            </Link>
            <a
              href="#hot"
              className="px-6 py-3 rounded-md border border-white/35 text-white text-sm md:text-base text-center whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              先看今日热榜
            </a>
          </div>

          <dl className="mt-10 md:mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-2xl">
            {gossipStats.map((s) => (
              <div key={s.label} className="border-l-2 border-accent-400/60 pl-3">
                <dt className="text-xs text-white/70 mb-1 flex items-center gap-1">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${s.icon} text-accent-300`}></i>
                  </span>
                  {s.label}
                </dt>
                <dd className="font-heading font-black text-xl md:text-2xl text-white">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}